import { render, staticRenderFns } from "./DialogSwitchIdea.vue?vue&type=template&id=41d0809a"
import script from "./DialogSwitchIdea.vue?vue&type=script&lang=js"
export * from "./DialogSwitchIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports